import PureCareExceptionReport from '../../pages/report/purecareExceptionReport/PureCareException';
import ShipmentStatusReport from '../../pages/report/shipmentStatusReport/ShipmentStatusReport';
import RemitIngestionReport from '../../pages/report/remitIngestion/RemitIngestion';
import LaneviewHeatmap from '../../pages/report/laneview_heatmap/LaneviewHeatmap';
import TnCostBreakdown from '../../pages/report/tnCostBreakdown/TnCostBreakdown';
import ExceptionReport from '../../pages/report/exceptionReport/ExceptionReport';
import DrillDownReport from '../../pages/report/drillDownReport/DrillDownReport';
import LaneviewTrends from '../../pages/report/laneviewTrends/LaneviewTrends';
import PoStatusReport from '../../pages/report/poStatusReport/poStatusReport';
import MakewellReport from '../../pages/report/makewellReport/MakewellReport';
import ParcelHeatmap from '../../pages/report/parcel_heatmap/ParcelHeatmap';
import FlexHubReport from '../../pages/report/flexHubReport/FlexHubReport';
import WidgetReport from '../../pages/report/widgetReports/widgetReports';
import ServiceLevel from '../../pages/report/servicelevel/ServiceLevel';
import ToggleReport from '../../pages/report/toggleReport/ToggleReport';
import TableReport from '../../pages/report/tableReports/TableReport';
import FormTracker from '../../pages/report/formTracker/FormTracker';
import ChartReport from '../../pages/report/chartReport/ChartReport';
import CalendarView from '../../pages/report/calendar/CalendarView';
import CostTrends from '../../pages/report/costTrends/CostTrends';
import Scoreboard from '../../pages/report/scoreboard/Scoreboard';
import DualReport from '../../pages/report/dualReport/DualReport';
import CUReport from '../../pages/report/clickupReport/CUReport';
import Reweigh from '../../pages/report/reweigh/reweigh';
import Audit from '../../pages/report/audit/Audit';
import { useParams } from 'react-router-dom';
import Remit from '../../pages/remit/Remit';

const ReportRenderer = () => {
    const { reportURL } = useParams();

    let reportComponent;
    switch (reportURL) {
      case 'trackingcostbreakdown':
        reportComponent = <TnCostBreakdown />;
        break;
      case 'reweigh':
        reportComponent = <Reweigh />;
        break;
      case 'laneviewtrend':
        reportComponent = <LaneviewTrends />;
        break;
      case 'formtracker':
        reportComponent = <FormTracker />;
        break;
      case 'serviceleveltype':
        reportComponent = <ServiceLevel />;
        break;
      case 'servicelevelmode':
        reportComponent = <ServiceLevel />;
        break;
      case 'servicelevel':
        reportComponent = <ServiceLevel />;
        break;
      case 'laneviewheatmap':
        reportComponent = <LaneviewHeatmap />;
        break;
      case 'remit':
        reportComponent = <Remit />
        break;
      case 'calendar':
        reportComponent = <CalendarView />
        break;
      case 'postatusreport':
        reportComponent = <PoStatusReport />;
        break;
      case 'exceptionreport':
        reportComponent = <ExceptionReport />;
        break;
      case 'makewellreport':
        reportComponent = <MakewellReport />;
        break;
      case 'costtrends':
        reportComponent = <CostTrends />;
        break;
      case 'tablereport':
        reportComponent = <TableReport />;
        break;
      case 'purecareexpcetionreport':
        reportComponent = <PureCareExceptionReport />;
        break;
      case 'flexhub':
        reportComponent = <FlexHubReport />;
        break;
      case 'audit':
        reportComponent = <Audit />;
        break;
      case 'remitingestion':
        reportComponent = <RemitIngestionReport />;
        break;
      case 'scoreboard':
        reportComponent = <Scoreboard />;
        break;
      case 'cureport':
        reportComponent = <CUReport />;
        break;
      case 'parcelheatmap':
        reportComponent = <ParcelHeatmap />;
        break;
      case 'widgetreport':
        reportComponent = <WidgetReport />;
        break;
      case 'togglereport':
        reportComponent = <ToggleReport />;
        break;
      case 'dualreport':
        reportComponent = <DualReport />;
        break;
      case 'chartreport':
        reportComponent = <ChartReport />;
        break;
      case 'drilldownreport':
        reportComponent = <DrillDownReport />;
        break;
      case 'shipmentstatus':
        reportComponent = <ShipmentStatusReport />
        break;
      default:
        reportComponent = <div>Report not found</div>;
    }
  return (
    <div>
      {reportComponent}
    </div>
  );
}

export default ReportRenderer